import { useEffect } from 'react';
import { useAlert } from '@/shared/lib/hooks/useAlert';
import { legacyErrorMessages } from '@/shared/model/types/error';
import { normalizeApiError } from '@/shared/lib/utils/apiError';
import { linkifyEmail } from '@/shared/lib/utils/linkifyEmail';

// В качестве <T> передавать интерфейс соответсвующий полям формы
// Иначе есть риск, что пользователь не будет проинформирован об ошибке
export const useFormError = <T>(error: any, setError: any, UnknownErrorAction?: () => void) => {
  const onAlert = useAlert();
  useEffect(() => {
    if (!error) return;
    const normalized = normalizeApiError(error);
    if (!normalized) {
      UnknownErrorAction ? UnknownErrorAction() : onAlert('Произошла неизвестная ошибка', true);
      return;
    }

    if (normalized.format === 'inputs' && normalized.fields) {
      const object = normalized.fields;

      Object.keys(object).forEach((key) => {
        if (key === 'captcha') {
          onAlert('Произошла ошибка при проверке капчи', true);
        } else if (key === 'birthDate') {
          setError(key as keyof T, {
            message: 'Допустимый возраст 8 - 99 лет',
          });
        } else {
          setError(key as keyof T, {
            message: (Array.isArray(object[key]) && object[key][0]) || 'Неверный формат',
          });
        }
      });
      return;
    }

    if (normalized.format === 'new') {
      if (normalized.code === 'INVALID_REQUEST' && normalized.fields) {
        const object = normalized.fields;
        Object.keys(object).forEach((key) => {
          setError(key as keyof T, {
            message: (Array.isArray(object[key]) && object[key][0]) || 'Неверный формат',
          });
        });
        return;
      }

      onAlert(linkifyEmail(normalized.message), true);
      return;
    }

    if (normalized.format === 'legacy') {
      if (normalized.code === 101117) {
        onAlert('Произошла ошибка при проверке капчи', true);
        return;
      }

      const numericCode = typeof normalized.code === 'number' ? normalized.code : undefined;
      const fallback = numericCode != null ? legacyErrorMessages[numericCode] : undefined;

      onAlert(linkifyEmail(normalized.message || fallback || 'Произошла ошибка'), true);
      return;
    }

    onAlert(linkifyEmail(normalized.message), true);
  }, [error, setError, onAlert, UnknownErrorAction]);
};
